import consumer from "./consumer"
consumer.subscriptions.create("LoginSessionChannel", {
    connected() {
      console.log("Login session channel connected")
    },

    received(data) {
        if (data.action !== "logout") return

        fetch("/users/sign_out", {
            method: "DELETE",
            headers: {
            "X-CSRF-Token": document
                .querySelector("meta[name='csrf-token']")
                .content,
            "Accept": "text/html"
            },
            credentials: "same-origin"
        }).then(() => {
            window.location.href = data.redirect_url
        })
    }
  }
)